import React from 'react';
import { Button, Container, Form , Icon} from 'semantic-ui-react';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { useMutation } from '@apollo/client';
import { ADD_COMMENT } from '../../../gql/comment';
import "./ComentForm.scss";

export default function ComentForm(props) {
  const {publication }= props;
  const [addComment] = useMutation(ADD_COMMENT);

  const formik = useFormik ({
    initialValues:{
      comment: "",
      description: "",
    },

    validationSchema: Yup.object({
      comment: Yup.string().required(),
    }),

    onSubmit:async(formData) => {
      try {
        await addComment ({
          variables:{
            input:{
              idPublication:  publication._id ,
              comment: formData.comment,
              description:formData.description,
            },
          },
        });
        formik.handleReset()
        

      } catch (error) {
        
      }
      
    }
    



  });
  return (

    <>
    <Container>
    
    <Form className='coment-form' onSubmit={formik.handleSubmit}>
        <Form.Input 
        placeholder= "comentario" 
        name = "comment"
        value={formik.values.comment} 
        onChange= {formik.handleChange}
        error={formik.errors.comment && true }/>


  <div>
<Button type= "submit">  Enviar .   <Icon name ="paper plane" /> </Button>
</div>
    </Form>
    
  </Container>



</>

  )
}
